/* eslint-disable no-return-assign */
import styled, { keyframes, css } from 'styled-components'

import { Flex, Box, Banner, getPaletteColor } from 'pcln-design-system'

export const StyledRoot = styled.div`
  border-top: 1px solid ${getPaletteColor('border.base')};
`

export const FullHeightDiv = styled.div`
  min-height: 100%;

  .opacity-mask {
    opacity: 0.6;
  }
`

export const ListingsHeader = styled.div`
  box-bottom: ${props =>
    props.showBoxShadow
      ? `1px solid ${getPaletteColor('border.base')(props)}`
      : 'none'};
  border-top: 1px solid ${getPaletteColor('border.base')};

  ${props => props.theme.mediaQueries.xl} {
    margin-bottom: 16px;
  }
`

export const ListingsBody = styled(Flex)`
  padding-top: 16px;
  padding-bottom: 16px;
  margin-bottom: 32px;
  margin-left: auto;
  margin-right: auto;
  max-width: 1380px;
  background-color: ${getPaletteColor('background.lightest')};
`

export const Left = styled.div`
  display: none;
  position: relative;
  width: 100%;
  margin: 0 16px 0 0;

  ${props => props.theme.flyQueries.desktop} {
    display: inline-block;
    max-width: 224px;
  }
`

/**
 * Styling notes for listings content:
 *    When ads are disabled, the content should fill to the right as there will not be a right column.
 *    When ads are displayed, content width should take into account right/left columns at each breakpoint.
 */
export const Middle = styled.div`
  width: 100%;
  position: relative;

  ${props => props.theme.flyQueries.tablethd} {
    width: calc(100% - ${props => (props.displayAds ? '160' : '0')}px);
  }

  ${props => props.theme.flyQueries.desktop} {
    padding: 0 10px;
    width: calc(
      100% -
        ${props =>
          props.displayAds && !props.is3ShelfVariant ? '430' : '252'}px
    );
  }

  ${props => props.theme.flyQueries.desktoplg} {
    width: calc(100% - ${props => (props.displayAds ? '570' : '252')}px);
  }

  ${props => props.theme.flyQueries.desktophd} {
    padding: 0;
  }
`

export const Right = styled(Box)`
  display: none;
  position: relative;
  width: 100%;

  ${props => props.theme.flyQueries.tablethd} {
    display: ${props => (props.is3ShelfVariant ? 'none' : 'inline-block')};
    max-width: 160px;
    margin: 0 6px;
    width: 100%;
  }

  ${props => props.theme.flyQueries.desktoplg} {
    display: inline-block;
    max-width: 300px;
    width: 100%;
  }

  ${props => props.theme.flyQueries.desktophd} {
    display: inline-block;
    margin: 0 0 0 16px;
  }
`

export const RightAdBox = styled(Box)`
  max-width: unset;
  overflow-x: hidden;

  ${props => props.theme.flyQueries.tablethd} {
    max-width: 160px;
  }

  ${props => props.theme.flyQueries.desktoplg} {
    max-width: 300px;
  }
`

export const BottomAdBox = styled(Box)`
  ${props => props.theme.flyQueries.desktoplg} {
    margin-right: 58px;
  }

  ${props => props.theme.flyQueries.desktoplg} {
    margin-right: 76px;
  }
`

const fadeout = keyframes`
  to {
    height: 0px;
    opacity: 0;
  }
`

const fadeoutRule = css`
  ${fadeout} 500ms ease-in 10s forwards;
`

export const SopqBanner = styled(Banner)`
  position: absolute;
  z-index: 10;
  top: 0;
  width: 100%;
  overflow: hidden;
  animation: ${fadeoutRule};
  padding: 20px;
`

export const CSHSSRWrapper = styled(Box)`
  background-color: ${getPaletteColor('background.light')};
  min-height: 68px;

  ${props => props.theme.mediaQueries.xl} {
    min-height: 112px;
  }
`
